import { Component, Input, OnInit } from '@angular/core';
import { CustomgridModel, QResult, Select } from '../models';
import { CoreService, HttpService } from '../services';





@Component({
  selector: 'q-reporting',
  templateUrl: './reporting.component.html',
  styleUrls: ['./reporting.component.css']
})

/*
* Composant pour l'affichage des editions
*/
export class ReportingComponent implements OnInit {

  // #region CONSTRUCTEUR

  constructor(
    private http: HttpService,
    private core: CoreService
  ) { }

  // #endregion

  // Nom du block contenant les éditions
  public codeBlock: string;
  @Input('CodeBlock')
  set CodeBlock(value: string) {
    this.codeBlock = value;
  }

  // Ident du BO principal
  public idDonnee: string;
  @Input('IdDonnee')
  set IdDonnee(value: string) {
    this.idDonnee = value;
  }

  // filtre passé a la grid [completeWhere]
  public filtreWhere: string = '';
  @Input('FiltreWhere')
  set FiltreWhere(value: string) {
    if (value != this.filtreWhere) {
      this.filtreWhere = value;
      this.ReloadGrid();
    } else {
      this.filtreWhere = value;
    }
  }

  // #region VARIABLES GLOBALES

  /** affiche ou non la grid*/
  public showGrid: boolean;
  /** stock le nom du fichier sélectionné par l'utilisateur */
  public fileNameForGrid: string;
  /** stock la liste des treeview retourné par le serveur à l'init */
  public lstTreeviews: Array<Select>;
  /** nom du block qui filtre la liste coté serveur */


  // #endregion

  // #region CYCLE DE VIE

  public ngOnInit(): void {
    this.fileNameForGrid = "";
    this.lstTreeviews = [];
    this.InitData();
  }

  // #endregion

  // #region FONCTIONS PUBLIQUES

  /**
   * Recharge la grid avec le fichier sélectionné
   * */
  public ReloadGrid(): void {
    this.showGrid = false;
    setTimeout(() => { this.showGrid = true }, 1);
  }


  // #endregion

  // #region FONCTIONS PRIVES

  /**
   *  charge la liste des treeviews par rapport au block envoyé
   * */
  private InitData() {
    this.http.getHttp<CustomgridModel>(`${this.core.AppParams.apiUrl}api/customgrid/getData/REPORTS/${this.codeBlock}`)
      .subscribe((result: CustomgridModel) => {
        if (!result.HasError) {
          this.lstTreeviews = result.Reports;
        }
      });
  }

  // #endregion

}
